import { ChangeDetectionStrategy, Component, Input } from '@angular/core';

@Component({
    selector: 'medsurf-design-content-image',
    changeDetection: ChangeDetectionStrategy.OnPush,
    templateUrl: './image.content.design.html',
    styleUrls: ['./image.content.design.scss'],
    standalone: false
})
export class ImageContentDesign {
  @Input({ required: true }) src!: string;
  @Input({ required: true }) alt!: string;
  @Input() inputClass?: string
  @Input() width = "100%";
  @Input() height?: string;
}
